import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { HeaderBar } from '../../component'
import { LoadingOverlay } from '../../component/loadingOverlay'
import { ChangeBranchModal } from '../../component/modaldialog/ModalChangeBranch'
import { STAFF_TABLE_CONFIG, TABLE_CONFIG_TYPE } from '../../constants/table/table'
import * as errorActions from '../../redux/actions/error.action'
import * as staffActions from '../../redux/actions/staff.action'
import { toCSV } from 'react-csv/lib/core'
import './style.css'
import { ModalAddStaff } from '../../component/modaldialog/ModalAddStaff'
import { useModalState } from '../../hooks/useModalState'

const BRANCHMOVEMENT_HEADER = [
  { label: 'รหัสพนักงาน', key: 'staffId' },
  { label: 'ชื่อ', key: 'name' },
  { label: 'อีเมล', key: 'email' },
  { label: 'สาขาที่ย้าย', key: 'branchName' },
  { label: 'รหัสสาขา', key: 'branchCode' },
  { label: 'วันที่เริ่ม', key: 'startDate' },
  { label: 'วันที่สิ้นสุด', key: 'endDate' },
  { label: 'ย้ายโดย', key: 'createdBy' },
  { label: 'วันที่ทำรายการ', key: 'createdAt' }
]

export const ChangeBranch: React.VFC = () => {
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [selectedData, setSelectedData] = useState()
  const [data, setData] = useState<any[]>([])
  const [openModalAddStaff, { close: handleCloseModalAddStaff, open: handleOpenModalAddStaff }] =
    useModalState(false)

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const data = await dispatch(staffActions.getStaffWithActiveBranch())
      setData(data as any)
    } catch (error) {
      dispatch(errorActions.setError(error))
    } finally {
      setIsLoading(false)
    }
  }

  const renderHeader = (header: TABLE_CONFIG_TYPE) => {
    return header.header.map(rowHeader => <th key={rowHeader.id}>{rowHeader.name}</th>)
  }

  const displayDateColumn = (date: any) => {
    if (!date) {
      return
    }

    return dayjs(date).format('DD/MM/YYYY')
  }

  const handleCancelButton = () => {
    setIsOpenModal(false)
  }

  const handleOpenModal = (data: any) => {
    setSelectedData(data)
    setIsOpenModal(!isOpenModal)
  }

  const filterData = () => {
    if (searchValue === '') {
      return data
    }

    return [...data].filter(
      item =>
        item.staffname.includes(searchValue) ||
        item.staffemail.includes(searchValue) ||
        item.staffid.includes(searchValue)
    )
  }

  const getBranchMoventsHistory = async (query?: any) => {
    try {
      const { fileName = '', ...otherQuery } = query
      setIsLoading(true)
      const data = await dispatch(staffActions.getBranchMovementsHistory(otherQuery))
      const blob = new Blob(['\uFEFF', toCSV(data as any, BRANCHMOVEMENT_HEADER, ',', '"')], {
        type: 'text/csv'
      })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.setAttribute('download', `ประวัติการย้ายสาขา${fileName}.csv`)
      a.setAttribute('target', '_blank')
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
      setIsLoading(false)
    } catch (error) {
      dispatch(errorActions.setError(error))
      setIsLoading(false)
    }
  }

  const renderTableBody = () => {
    return filterData().map((rowBody: any, index: number) => {
      return (
        <tr key={index}>
          <td>{rowBody.staffid}</td>
          <td>{rowBody.staffname}</td>
          <td>{rowBody.regularbranchname}</td>
          <td>{displayDateColumn(rowBody.startdate)}</td>
          <td>{displayDateColumn(rowBody.enddate)}</td>
          <td>{rowBody.branchmovementbranchname}</td>
          <td className="column-actions">
            <button className="btn-change-branch" onClick={() => handleOpenModal(rowBody)}>
              เปลี่ยนสาขา
            </button>
            <button
              onClick={() =>
                getBranchMoventsHistory({
                  email: rowBody.staffemail,
                  fileName: ` ${rowBody.staffname}`
                })
              }
              className="btn-export-history"
            >
              ดูประวัติการย้ายสาขา
            </button>
          </td>
        </tr>
      )
    })
  }

  const onChangeBranchSuccess = () => {
    handleCancelButton()
    fetchData()
  }

  const onCreateNewStaffSuccess = () => {
    handleCloseModalAddStaff()
    fetchData()
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      {isLoading && <LoadingOverlay />}
      <HeaderBar>
        <div className="header-bar-text">เปลี่ยนแปลงสาขา</div>
      </HeaderBar>
      <div className="container">
        <div className="header-actions">
          <button className="btn-add-new-staff" onClick={handleOpenModalAddStaff}>
            เพิ่มพนักงานใหม่
          </button>
          <button
            className="btn-export-history-all"
            onClick={() => getBranchMoventsHistory({ fileName: 'ทั้งหมด' })}
          >
            ดูประวัติการย้ายสาขาทั้งหมด
          </button>
        </div>
        <form>
          <label className="group-label-input">
            <span>ค้นหา</span>
            <input
              className={`field-input`}
              type="test"
              name="search"
              placeholder="รหัสพนักงาน, ชื่อ-นามสกุลพนักงาน"
              autoComplete="off"
              value={searchValue}
              onChange={e => {
                setSearchValue(e.target.value)
              }}
            />
          </label>
        </form>
        <div>
          <div className="staff-table-content">
            <table className="table-list">
              <thead>
                <tr>
                  {renderHeader(STAFF_TABLE_CONFIG)}
                  <th></th>
                </tr>
              </thead>
              <tbody key="tbody">{renderTableBody()}</tbody>
            </table>
          </div>
        </div>
      </div>
      <ChangeBranchModal
        handleCancelbutton={handleCancelButton}
        onSuccess={onChangeBranchSuccess}
        isOpenModal={isOpenModal}
        selectedData={selectedData}
      />
      <ModalAddStaff
        isOpen={openModalAddStaff}
        onCancel={handleCloseModalAddStaff}
        onSuccess={onCreateNewStaffSuccess}
      />
    </div>
  )
}
